import React, { Component } from "react";
import * as Log from "../../common/Feedback/Log";
import * as Format from "../../common/FormatFunctions";
import { LoadScreen } from "../Common/LoadScreen";
import Board from "react-trello";
import * as pr from "../../common/PrimeComponents";
import { formatDate } from "fullcalendar";

export class BPMKanban extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      cardSelected: null,
      parsedKanbanData: []
    };

    this.logger = Log;
  }

  componentDidMount = () => {
    this.renderData();
  };

  renderData = () => {
    this.setState({ loaded: false });
    this.logger.info(this.props.data);
    if (Format.isNotNull(this.props.data)) {
      let kanbanColumns = this.props.data;
      let lanes = [];
      if (Format.isNotNull(kanbanColumns.columnList)) {
        kanbanColumns.columnList.forEach(element => {
          let cards = [];
          if (Format.isNotNull(element.cardList)) {
            element.cardList.forEach(card => {
              let description = (
                <span>
                  <b>Id: </b>
                  {card.dnumber || ""}
                  <br />
                  <b>Customer Name: </b>
                  {card.clientDetails
                    ? card.clientDetails.businessName || ""
                    : ""}
                  <br />
                  <b>Order Number </b>
                  {card.orderSequenceNumber || ""}
                  <br />
                  <b>Description: </b>
                  {card.shortDescription
                    ? card.shortDescription || ""
                    : card.name
                    ? card.name || ""
                    : ""}
                  <br />
                  <b>Type: </b>
                  {card.entityType || ""}
                </span>
              );
              cards.push({
                id: card.entityId,
                title: card.name,
                label: card.label,
                description: description,
                style: card.style,
                metadata: {
                  extraProperty: "Hello From " + card.entityId,
                  cardBean: card
                }
              });
            });
          }
          this.logger.info(cards);
          lanes.push({
            id: element.id,
            style: element.style,
            title: element.title,
            description: element.description,
            label: "",
            draggable: element.draggable,
            cards: cards
          });
        });

        this.setState({ parsedKanbanData: { lanes: lanes }, loaded: true });
      } else {
        this.setState({ parsedKanbanData: { lanes: [] }, loaded: true });
      }
    } else {
      this.setState({ parsedKanbanData: { lanes: [] }, loaded: true });
    }
  };

  parseDataAfterCardColumnChange = (originalCardBean, targetLaneId) => {
    //Update Original Bean to show the new Changes
    var changedCardBean = Format.deepCopy(originalCardBean);
    changedCardBean.column = targetLaneId;

    //Create the original Card List
    var originalCardList = [];
    originalCardList.push(originalCardBean);

    //Create the Updated Card List
    var changedCardList = [];
    changedCardList.push(changedCardBean);

    //Create the FROM Column
    var kanbanFromColumn = {};
    kanbanFromColumn.title = "FROM";
    kanbanFromColumn.cardList = originalCardList;

    //Crete the TO Column
    var kanbanToColumn = {};
    kanbanToColumn.title = "TO";
    kanbanToColumn.cardList = changedCardList;

    //Create the Kanban Column List
    var kanbanColumns = [];
    kanbanColumns.push(kanbanFromColumn);
    kanbanColumns.push(kanbanToColumn);

    //Create the Kanban Swim Lane
    var kanbanSwimLane = {};
    kanbanSwimLane.columnList = kanbanColumns;

    //Create the Kanban Swim Lane List
    var kanbanSwimLanes = [];
    kanbanSwimLanes.push(kanbanSwimLane);

    // Create the Kanban and Return the Kanban board for Update
    var kanbanBoard = {};
    kanbanBoard.swimLaneList = kanbanSwimLanes;
    kanbanBoard.title = "UPDATE";

    return kanbanBoard;
  };
  handleDragEnd = async (
    cardId,
    sourceLaneId,
    targetLaneId,
    position,
    cardDetails
  ) => {
    this.logger.info("Drag End Applied");
    this.logger.info("Card  : " + cardId);
    this.logger.info("Source  : " + sourceLaneId);
    this.logger.info("Target  : " + targetLaneId);

    this.logger.info("Position  : " + position);
    this.logger.info(cardDetails);

    if (sourceLaneId !== targetLaneId) {
      var kanbanBoard = this.parseDataAfterCardColumnChange(
        cardDetails.metadata.cardBean,
        targetLaneId
      );
      this.logger.info(kanbanBoard);
      if (Format.isFunction(this.props.cardMoved)) {
        this.props.cardMoved(kanbanBoard);
      } else {
        this.logger.info(
          "No Card Moved Function Attached, see props.cardMoved"
        );
      }
    } else {
      this.logger.info("Card Event Fired, but Column remained the same");
    }
  };

  handleCardClick = (cardId, metadata, laneId) => {
    this.logger.info(`Card clicked -> ${cardId}`);
    this.setState({ cardSelected: { cardId: cardId, metadata: metadata } });
    if (!Format.isFunction(this.props.cardSelected)) {
      this.logger.info("No Card Selected Attached, see props.cardSelected");
    } else {
      this.props.cardSelected({ cardId: cardId, metadata: metadata });
    }
  };

  handleLaneClick = laneId => {
    this.logger.info(` Lane clicked -> ${laneId}`);
    if (Format.isFunction(this.props.laneSelected)) {
      this.props.laneSelected(laneId);
    } else {
      this.logger.info(
        "No Lane Selected Function Attached, see props.laneSelected"
      );
    }
  };
  // #endregion
  setEventBus = handle => {
    this.setState({ kanbanEventBus: handle });
  };

  render() {
    if (this.props.visible === true) {
      return (
        <div>
          {this.state.loaded === false ? (
            <LoadScreen />
          ) : (
            <span className="p-float-label">
              <Board
                data={this.state.parsedKanbanData}
                onCardClick={this.handleCardClick}
                onLaneClick={this.handleLaneClick}
                cardDraggable={this.props.cardDraggable}
                laneDraggable={true}
                eventBusHandle={this.setEventBus}
                handleDragEnd={this.handleDragEnd}
                hideCardDeleteIcon={true}
                style={{
                  whiteSpace: "pre",
                  height: "100%",
                  overflow: "unset",
                  backgroundColor: "transparent"
                }}
              />
              <label></label>
              {/* {this.getCardView()} */}
            </span>
          )}
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/BPMKanban.js